import { Edit, SimpleForm, TextInput, NumberInput, required, minValue } from 'react-admin';
import { validateNotEmpty } from '../../common/VideoPlayer/util';

const MetaDataEdit = () => {
    return (
        <Edit redirect="list" mutationMode="pessimistic">
            <SimpleForm>
                <TextInput
                    source="name"
                    label="Name"
                    validate={[required(), validateNotEmpty]}
                    fullWidth
                />
                <NumberInput
                    source="displayOrder"
                    label="Display Order"
                    fullWidth
                    helperText="Optional: Enter a number for ordering (default: 0)"
                    validate={[required(), minValue(1)]}
                />
            </SimpleForm>
        </Edit>
    );
};

export default MetaDataEdit;
